import {
  QCTaskDetailSubheaderKindEnum,
  QCTasksTableConfigOptions,
} from './types';

export const STATUS_PILL_WIDTH = 200;

export const defaultOpts: Required<QCTasksTableConfigOptions> = {
  iconColWidth: 50,
  detailIconIndentPx: 15,
  headerBgClass: '',
  rowBgClass: '',
  headerBgInline: '',
  rowBgInline: '',
  headerTextClass: 'text-spanishGray font-medium',
  dataFontSizePx: 14,
  dataLineHeightPx: 30,
  actionIconSizeClass: 'text-[25px]',
  dateTextClass: 'text-black',
  timeTextClass: 'text-spanishGray',
};

export const SUBHEADER_KINDS = [
  QCTaskDetailSubheaderKindEnum.EXEC,
  QCTaskDetailSubheaderKindEnum.DXA,
  QCTaskDetailSubheaderKindEnum.CT,
  QCTaskDetailSubheaderKindEnum.XRAY,
  QCTaskDetailSubheaderKindEnum.MRI,
  QCTaskDetailSubheaderKindEnum.PDF,
  QCTaskDetailSubheaderKindEnum.CSV,
  QCTaskDetailSubheaderKindEnum.MISC,
] as const;

export const MODALITY_SUBHEADERS: Array<
  Exclude<QCTaskDetailSubheaderKindEnum, QCTaskDetailSubheaderKindEnum.EXEC>
> = [
  QCTaskDetailSubheaderKindEnum.DXA,
  QCTaskDetailSubheaderKindEnum.CT,
  QCTaskDetailSubheaderKindEnum.XRAY,
  QCTaskDetailSubheaderKindEnum.MRI,
  QCTaskDetailSubheaderKindEnum.PDF,
  QCTaskDetailSubheaderKindEnum.CSV,
  QCTaskDetailSubheaderKindEnum.MISC,
];
